import { render } from "./AbstractWelcome.vue?vue&type=template&id=3e74727f"
import script from "./AbstractWelcome.vue?vue&type=script&lang=js"
export * from "./AbstractWelcome.vue?vue&type=script&lang=js"

import exportComponent from "/home/blissfulapps/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__